var _defs, _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_3_1",
    "data-name": "Component 3 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108.193,
    height: 47.539,
    viewBox: "0 0 108.193 47.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1171d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cc8eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 0.49,
    x2: 1,
    y2: 0.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.001,
    y1: 0.487,
    x2: 1.001,
    y2: 0.487,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0,
    y1: 0.505,
    x2: 0.999,
    y2: 0.505,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0,
    y1: 0.487,
    x2: 1,
    y2: 0.487,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -0.001,
    y1: 0.501,
    x2: 1.001,
    y2: 0.501,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -0.001,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0,
    y1: 0.49,
    x2: 1,
    y2: 0.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 0,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 0,
    y1: 0.508,
    x2: 1,
    y2: 0.508,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 0,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 0,
    y1: 0.503,
    x2: 1,
    y2: 0.503,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 0,
    y1: 0.503,
    x2: 1,
    y2: 0.503,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 0,
    y1: 0.495,
    x2: 1,
    y2: 0.495,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 0,
    y1: 0.499,
    x2: 1.001,
    y2: 0.499,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 0,
    y1: 0.497,
    x2: 1.001,
    y2: 0.497,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 0,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 0,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 0,
    y1: 0.495,
    x2: 1,
    y2: 0.495,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 0,
    y1: 0.508,
    x2: 1,
    y2: 0.508,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 0,
    y1: 0.492,
    x2: 1,
    y2: 0.492,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 0,
    y1: 0.497,
    x2: 1,
    y2: 0.497,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 0,
    y1: 0.498,
    x2: 1,
    y2: 0.498,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: -0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 0.001,
    y1: 0.5,
    x2: 1.001,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 0.001,
    y1: 0.5,
    x2: 1.001,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 0,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 0,
    y1: 0.494,
    x2: 1,
    y2: 0.494,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 0,
    y1: 0.494,
    x2: 1,
    y2: 0.494,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 0,
    y1: 0.506,
    x2: 1,
    y2: 0.506,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 0,
    y1: 0.498,
    x2: 1,
    y2: 0.498,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 0,
    y1: 0.488,
    x2: 1,
    y2: 0.488,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 0,
    y1: 0.496,
    x2: 1,
    y2: 0.496,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 0,
    y1: 0.488,
    x2: 1,
    y2: 0.488,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 0,
    y1: 0.506,
    x2: 1,
    y2: 0.506,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 0,
    y1: 0.492,
    x2: 1,
    y2: 0.492,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 0,
    y1: 0.496,
    x2: 1,
    y2: 0.496,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 0,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 0,
    y1: 0.5,
    x2: 1.001,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 0.001,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: -0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 0,
    y1: 0.505,
    x2: 1,
    y2: 0.505,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 0,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 0,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 1.535,
    y1: 0,
    x2: 0.125,
    y2: 0.711,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aai_logo",
    "data-name": "Aai logo",
    transform: "translate(-63.925 -38.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1588",
    "data-name": "Group 1588",
    transform: "translate(63.925 38.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1578",
    "data-name": "Group 1578",
    transform: "translate(0.171 0.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M82.17,123.021h1.647l.4-.4h1.75v-.038H84.205l-.4.4H82.17Z",
    transform: "translate(-80.572 -114.587)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M82.17,118.05h1.258l.722-.722h1.433v-.038H84.134l-.722.722H82.17Z",
    transform: "translate(-80.572 -109.81)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1432",
    "data-name": "Rectangle 1432",
    width: 1.242,
    height: 0.038,
    transform: "translate(1.606 8.009)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1433",
    "data-name": "Rectangle 1433",
    width: 0.426,
    height: 0.038,
    transform: "translate(1.634 7.815)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M82.68,92.5H83.1l1.022-1.022h2.154l1.8-1.8h1.451V89.64H88.06l-1.8,1.8H84.107l-1.023,1.023h-.4Z",
    transform: "translate(-81.033 -84.84)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M83.316,65.9l.608-.6h2.76l3.868-3.868h.7l.44-.44h.962V60.96h-.977l-.44.44h-.7l-3.868,3.868h-2.76l-.619.608Z",
    transform: "translate(-81.583 -58.941)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M86.42,73.73h2.946l3.153-3.153-.026-.027L89.35,73.692H86.42Z",
    transform: "translate(-84.41 -67.601)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M90.77,79.5h2.439l2.257-2.257-.027-.026-2.246,2.246H90.77Z",
    transform: "translate(-88.338 -73.625)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M88.69,57.674H91.4l3.365-3.366h1.128l.931-.931H98.2V53.34H96.808l-.931.931H94.75l-3.365,3.365H88.69Z",
    transform: "translate(-86.46 -52.06)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M91.36,74.033h2.521l2.257-2.257-.026-.026L93.865,74H91.36Z",
    transform: "translate(-88.871 -68.685)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M92.52,71.294H95l2.256-2.257-.026-.027-2.246,2.247H92.52Z",
    transform: "translate(-89.919 -66.211)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M67.021,166.994h.038v-.5l-.418-.418h-.552l-.362-.362v-.257H65.69v.272l.384.384h.552l.4.4Z",
    transform: "translate(-65.69 -153.309)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M80.224,185.284l.027-.026-.319-.318H79.7v.037h.216Z",
    transform: "translate(-78.342 -170.9)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M80.88,190.675h.037V190.2l.287-.286h.4v-.038h-.417l-.308.308Z",
    transform: "translate(-79.407 -175.361)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M81.95,201.267h.038v-.256l.178-.177v-.555l-.26-.259-.026.026.248.248v.524L81.95,201Z",
    transform: "translate(-80.31 -184.518)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M85.24,208.312H87.1l.646-.646-.026-.026-.635.634H85.24Z",
    transform: "translate(-83.344 -191.399)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M83.35,209.722h2.068l.7-.7L86.088,209l-.686.685H83.35Z",
    transform: "translate(-81.638 -192.627)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M85.43,211.117h1.909l.731-.731-.026-.026-.72.72H85.43Z",
    transform: "translate(-83.516 -193.855)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M88.09,212.541h1.656l.8-.8-.027-.027-.793.793H88.09Z",
    transform: "translate(-85.918 -195.075)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M69.295,163.074l.026-.027-.487-.487H67.69v.037h1.128Z",
    transform: "translate(-67.496 -150.69)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1434",
    "data-name": "Rectangle 1434",
    width: 1.132,
    height: 0.038,
    transform: "translate(0.427 11.631)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1435",
    "data-name": "Rectangle 1435",
    width: 0.78,
    height: 0.038,
    transform: "translate(0.596 11.404)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M79.146,138.1l.313-.312v-.535h-.038v.52l-.3.3Z",
    transform: "translate(-77.818 -127.834)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M84.263,131.65l.027-.026-.314-.314H82.86v.038h1.1Z",
    transform: "translate(-81.195 -122.47)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1436",
    "data-name": "Rectangle 1436",
    width: 0.879,
    height: 0.038,
    transform: "translate(1.719 9.117)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M87.35,137.211l.027-.026-.715-.715h-.635l-.217.217.027.027.206-.207h.6Z",
    transform: "translate(-83.859 -127.13)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M90.72,146.74h.4l.264-.264-.027-.026-.252.252H90.72Z",
    transform: "translate(-88.293 -136.142)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M94.017,72.534l1.847-1.847-.026-.027L93.99,72.508Z",
    transform: "translate(-91.246 -67.701)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M97.706,63.757l2.78-2.779h1.362V60.94h-1.378L97.68,63.731Z",
    transform: "translate(-94.578 -58.923)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M101.4,68.913l2.237-2.236-.027-.027-2.236,2.237Z",
    transform: "translate(-97.91 -64.08)",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M105.077,44.973l2.448-2.448H108.9l.438-.438h.914l1.92-1.92-.027-.027-1.908,1.909h-.914l-.438.438H107.51l-2.46,2.46Z",
    transform: "translate(-101.234 -40.14)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M108.766,69.283l2.2-2.2-.027-.027-2.2,2.2Z",
    transform: "translate(-104.566 -64.45)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M112.447,72.534l1.847-1.847-.026-.027-1.848,1.848Z",
    transform: "translate(-107.889 -67.701)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M116.136,69.139l2.213-2.213-.026-.026-2.213,2.213Z",
    transform: "translate(-111.221 -64.305)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M75.287,143.82l.983-.983-.026-.027-.984.984Z",
    transform: "translate(-74.332 -132.855)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M73.6,151.063h.8l.5-.5-.026-.026-.486.486H73.6Z",
    transform: "translate(-72.833 -139.836)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M80.716,148.523l.6-.6-.026-.027-.6.6Z",
    transform: "translate(-79.236 -137.452)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M78.166,146.15l.773-.774-.026-.026-.773.773Z",
    transform: "translate(-76.933 -135.149)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M83.837,108.705l.828-.829-.026-.026-.829.828Z",
    transform: "translate(-82.053 -101.285)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M93.5,138.864l.027-.027-.428-.427-.026.026Z",
    transform: "translate(-90.415 -128.882)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M71.67,166.532l.027-.026-.6-.6h-.8v.038h.786Z",
    transform: "translate(-69.853 -153.715)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1437",
    "data-name": "Rectangle 1437",
    width: 0.656,
    height: 0.038,
    transform: "translate(0.594 12.527)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M83.179,181.785h.992v-.038h-.976l-.688-.687-.026.026Z",
    transform: "translate(-80.852 -167.396)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M82.1,173.559h1.616v-.038h-1.6l-.867-.867v-.414H81.21v.43Z",
    transform: "translate(-79.705 -159.432)",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M86.289,155.116h2.08v-.038H86.3l-.976-.976v-.512l.493-.494-.026-.026-.5.5v.543Z",
    transform: "translate(-83.39 -142.12)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M88.051,168.057h2.423l.921-.921-.026-.026-.91.91H88.067l-.681-.681-.026.026Z",
    transform: "translate(-85.259 -154.799)",
    fill: "url(#linear-gradient-46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M88.051,170.973h2.423l.916-.915h3.354v-.038h-3.37l-.915.915H88.067l-.681-.681-.026.027Z",
    transform: "translate(-85.259 -157.427)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M86.512,174h2.571l.921-.92-.026-.027-.91.91h-2.54l-.681-.682-.027.027Z",
    transform: "translate(-83.868 -160.163)",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M88.66,147.33h.807l.484-.483-.027-.027-.472.473H88.66Z",
    transform: "translate(-86.433 -136.476)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M89.86,156.926l.027-.026-.749-.75v-.469l.294-.295-.026-.026-.305.305v.5Z",
    transform: "translate(-86.83 -144.188)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M94.75,139.188h.489l.822-.822v-.391l-.526-.526-.026.026.515.515v.36l-.8.8H94.75Z",
    transform: "translate(-91.932 -128.015)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M84.128,130.184l.026-.026-.6-.6.363-.363v-.454H81.9v.038h1.978v.4l-.378.378Z",
    transform: "translate(-80.328 -120.149)",
    fill: "url(#linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M90.056,112.69l.862-.862h2l.718.719h2.475v-.038H93.649l-.719-.719H90.9l-.873.873Z",
    transform: "translate(-87.67 -104.843)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M97.06,115.149h1.531v-.038H97.075l-.641-.641H94.7l-.613.613.027.027.6-.6h1.7Z",
    transform: "translate(-91.336 -107.263)",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M98.576,120.614l.437-.436h1.5v-.038H99l-.447.448Z",
    transform: "translate(-95.364 -112.383)",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M93.19,148.881h.7l1.073-1.073h1.889v-.038h-1.9l-1.073,1.073H93.19Z",
    transform: "translate(-90.524 -137.334)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M93.19,151.894h.736l1.116-1.117h2.19v-.037H95.026l-1.116,1.116h-.72Z",
    transform: "translate(-90.524 -140.016)",
    fill: "url(#linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M96.564,165.033a2.984,2.984,0,0,0,.554-.011l.654-.654h1.452v-.038H97.757l-.661.661c-.1.007-1.32,0-1.8,0l-.645-.645-.026.026.655.655h.008C95.888,165.031,96.293,165.033,96.564,165.033Z",
    transform: "translate(-91.815 -152.288)",
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M99.285,162.543h1.538l.7-.7h1.949v-.037H101.5l-.7.7H99.3l-.413-.413-.027.026Z",
    transform: "translate(-95.644 -150.013)",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M103.66,159.847H105.1l.6-.6h2.221v-.038h-2.237l-.6.6H103.66Z",
    transform: "translate(-99.978 -147.665)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M104.906,154.8l.86-.86h3.209V153.9h-3.225l-.871.871Z",
    transform: "translate(-101.08 -142.87)",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M108.85,157.344h.764l.536-.536h2.339v-.038h-2.354l-.536.536h-.749Z",
    transform: "translate(-104.665 -145.462)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M112.757,156.952l.375-.376-.027-.026-.375.375Z",
    transform: "translate(-108.169 -145.263)",
    fill: "url(#linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1438",
    "data-name": "Rectangle 1438",
    width: 5.215,
    height: 0.038,
    transform: "translate(4.354 10.061)",
    fill: "url(#linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M105.173,135.21h5.012v-.038h-5l-.622-.622-.027.026Z",
    transform: "translate(-100.773 -125.396)",
    fill: "url(#linear-gradient-65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M105.193,125.629h2.989v-.038h-2.974l-.661-.661h-1.975l-.212.213.026.026.2-.2h1.944Z",
    transform: "translate(-98.804 -116.709)",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M107.564,129.355h3.316v-.038h-3.3L107,128.74H105.31v.038h1.677Z",
    transform: "translate(-101.468 -120.149)",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M108.9,133.172h3.954v-.038h-3.939l-.564-.564H107v.038h1.332Z",
    transform: "translate(-102.995 -123.608)",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M109.431,135.127h.926v-.038h-.91l-.339-.339-.027.026Z",
    transform: "translate(-104.873 -125.577)",
    fill: "url(#linear-gradient-69)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1439",
    "data-name": "Rectangle 1439",
    width: 0.624,
    height: 0.038,
    transform: "translate(4.613 9.244)",
    fill: "url(#linear-gradient-70)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M122.9,95.269l1.6-1.6h2.638V93.63h-2.654l-1.611,1.611Z",
    transform: "translate(-117.326 -88.444)",
    fill: "url(#linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M130.515,108.3h1.117v-.038h-1.1l-.833-.834-.027.027Z",
    transform: "translate(-123.466 -100.906)",
    fill: "url(#linear-gradient-72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M127.136,110.5l.026-.026-.616-.616-.026.027Z",
    transform: "translate(-120.622 -103.1)",
    fill: "url(#linear-gradient-73)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1440",
    "data-name": "Rectangle 1440",
    width: 4.293,
    height: 0.038,
    transform: "translate(6.183 8.252)",
    fill: "url(#linear-gradient-74)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1441",
    "data-name": "Rectangle 1441",
    width: 4.21,
    height: 0.038,
    transform: "translate(6.498 8.552)",
    fill: "url(#linear-gradient-75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M82.836,192.752l.406-.406-.026-.026-.406.406Z",
    transform: "translate(-81.15 -177.565)",
    fill: "url(#linear-gradient-76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M84.831,198.191h1.142v-.038h-1.1v-.446l-.366-.366.225-.226-.026-.026-.252.252.381.381Z",
    transform: "translate(-82.631 -181.872)",
    fill: "url(#linear-gradient-77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M84.817,203.045l.258-.258h1.39l.77-.769H89v-.038H87.22l-.77.77H85.06l-.27.269Z",
    transform: "translate(-82.938 -186.288)",
    fill: "url(#linear-gradient-78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M87.527,204.7l.121-.121H89l.738-.738h1.923V203.8H89.719l-.738.738H87.633l-.133.133Z",
    transform: "translate(-85.385 -187.931)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M90.31,206.32h1.316l.713-.713h1.839v-.037H92.323l-.713.713h-1.3Z",
    transform: "translate(-87.923 -189.53)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M110.146,208.29l.7-.7-.322-.322-.027.027.3.295-.671.672Z",
    transform: "translate(-105.812 -191.065)",
    fill: "url(#linear-gradient-81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M114.906,208.2l.59-.591-.3-.305-.027.027.278.278-.563.563Z",
    transform: "translate(-110.111 -191.092)",
    fill: "url(#linear-gradient-82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M120.109,216.191h2.631v-.037h-2.615l-.613-.614H118.42v.038H119.5Z",
    transform: "translate(-113.307 -198.533)",
    fill: "url(#linear-gradient-83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M122.2,214.2h2.274v-.038h-2.258l-.565-.564H120.5v.038h1.131Z",
    transform: "translate(-115.186 -196.781)",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1442",
    "data-name": "Rectangle 1442",
    width: 5.759,
    height: 0.038,
    transform: "translate(5.38 16.259)",
    fill: "url(#linear-gradient-85)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1443",
    "data-name": "Rectangle 1443",
    width: 2.765,
    height: 0.038,
    transform: "translate(5.585 16.499)",
    fill: "url(#linear-gradient-86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M136.128,213.4h2v-.038h-1.984l-.387-.388-.027.027Z",
    transform: "translate(-128.939 -196.212)",
    fill: "url(#linear-gradient-87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M140.33,213.178h1.756v-.038h-1.74l-.169-.17-.027.027Z",
    transform: "translate(-132.93 -196.212)",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M88.795,200.161h.774l.613-.613h2.067v-.038H90.166l-.613.613H88.81l-.563-.563-.027.026Z",
    transform: "translate(-86.035 -184.057)",
    fill: "url(#linear-gradient-72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M89.288,196.025h.482l.532-.532h2.113v-.038H90.287l-.532.532H89.3l-.748-.748-.026.027Z",
    transform: "translate(-86.315 -180.201)",
    fill: "url(#linear-gradient-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M90.877,177.788l.244-.244h1.392l.491-.491h.839l.907-.906h.927v-.038h-.942l-.907.907h-.84l-.49.49H91.1l-.255.256Z",
    transform: "translate(-88.41 -162.926)",
    fill: "url(#linear-gradient-78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M93.076,188.592l.284-.283h1.322l.48-.481h5.216v-.038H95.146l-.48.481H93.345l-.295.294Z",
    transform: "translate(-90.397 -173.474)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M94.826,191.746l.341-.34h1.387l.408-.408h5.208v-.038H96.947l-.408.408H95.152l-.352.352Z",
    transform: "translate(-91.977 -176.336)",
    fill: "url(#linear-gradient-78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M97.906,197.892l.356-.356-.026-.026-.356.355Z",
    transform: "translate(-94.759 -182.251)",
    fill: "url(#linear-gradient-94)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1444",
    "data-name": "Rectangle 1444",
    width: 0.386,
    height: 0.038,
    transform: "translate(1.135 14.373)",
    fill: "url(#linear-gradient-95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M117.877,193.488l.18-.18h3.237v-.038h-3.252l-.192.191Z",
    transform: "translate(-112.793 -178.422)",
    fill: "url(#linear-gradient-96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M127.026,180.163l.577-.576-.027-.027-.576.577Z",
    transform: "translate(-121.055 -166.042)",
    fill: "url(#linear-gradient-97)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1445",
    "data-name": "Rectangle 1445",
    width: 2.455,
    height: 0.038,
    transform: "translate(6.429 14.089)",
    fill: "url(#linear-gradient-98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1446",
    "data-name": "Rectangle 1446",
    width: 3.831,
    height: 0.038,
    transform: "translate(6.639 13.812)",
    fill: "url(#linear-gradient-99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1447",
    "data-name": "Rectangle 1447",
    width: 2.727,
    height: 0.038,
    transform: "translate(6.526 6.313)",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M135.187,97.637l.569-.569h2.709V97.03h-2.725l-.581.581Z",
    transform: "translate(-128.424 -91.514)",
    fill: "url(#linear-gradient-101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M140.746,100.545l.258-.257h2.182v-.038h-2.2l-.269.269Z",
    transform: "translate(-133.445 -94.422)",
    fill: "url(#linear-gradient-102)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1448",
    "data-name": "Rectangle 1448",
    width: 2.405,
    height: 0.038,
    transform: "translate(6.749 6.588)",
    fill: "url(#linear-gradient-103)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1449",
    "data-name": "Rectangle 1449",
    width: 0.986,
    height: 0.038,
    transform: "translate(7.114 7.063)",
    fill: "url(#linear-gradient-104)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M113.163,218.929h1.579v-.037h-1.564l-1.211-1.212h-.755l-.4.4h-.546v.038h.561l.4-.4h.723Z",
    transform: "translate(-105.776 -200.289)",
    fill: "url(#linear-gradient-105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M108.88,217.775h.567l.229-.229-.027-.026-.217.217h-.552Z",
    transform: "translate(-104.521 -200.145)",
    fill: "url(#linear-gradient-106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M122.683,222.645l.026-.027-1.638-1.638H120.5v.038h.556Z",
    transform: "translate(-115.015 -203.269)",
    fill: "url(#linear-gradient-107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M142.99,41.826h1.3l1.67-1.67-.026-.026-1.659,1.658h-1.28Z",
    transform: "translate(-135.324 -39.955)",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1585",
    "data-name": "Group 1585",
    transform: "translate(6.178 0.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M170.2,80.2H158.567l-3.447,3.448v.983h.049v-.963l3.419-3.418H170.2Z",
    transform: "translate(-152.456 -76.786)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M171.6,81.76H160.03l-3.36,3.359v.921h.05v-.9l3.33-3.331H171.6Z",
    transform: "translate(-153.855 -78.195)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M173,83.31H161.491l-3.271,3.271v.858h.05V86.6l3.241-3.241H173Z",
    transform: "translate(-155.255 -79.594)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M174.4,84.86H162.953l-3.183,3.183v.8h.05v-.776l3.153-3.153H174.4Z",
    transform: "translate(-156.655 -80.994)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M175.8,86.41H164.415L161.32,89.5v.734h.05v-.713l3.066-3.066H175.8Z",
    transform: "translate(-158.054 -82.394)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M177.2,87.96h-11.32l-3.008,3.007v.672h.05v-.651L165.9,88.01h11.3Z",
    transform: "translate(-159.454 -83.794)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M178.607,89.51H167.348l-2.919,2.919v.609h.049V92.45l2.889-2.889h11.238Z",
    transform: "translate(-160.863 -85.193)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M180.006,91.07h-11.2l-2.83,2.83v.547h.05v-.526l2.8-2.8h11.175Z",
    transform: "translate(-162.263 -86.602)",
    fill: "url(#linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M181.406,92.62H170.272l-2.742,2.742v.485h.05v-.463l2.713-2.713h11.113Z",
    transform: "translate(-163.662 -88.002)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M182.806,94.17H171.735l-2.655,2.655v.422h.05v-.4l2.625-2.625h11.051Z",
    transform: "translate(-165.062 -89.401)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1579",
    "data-name": "Group 1579",
    transform: "translate(3.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M177.709,44.99H166.078l-3.448,3.448v1.269h.05V48.458L166.1,45.04h11.611Z",
    transform: "translate(-162.63 -44.99)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M179.109,46.54H167.54l-3.36,3.36v1.207h.05V49.92l3.33-3.33h11.549Z",
    transform: "translate(-164.03 -46.39)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M180.509,48.1H169l-3.271,3.27v1.145h.05V51.392l3.242-3.242h11.486Z",
    transform: "translate(-165.429 -47.798)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M181.917,49.65H170.472l-3.182,3.183v1.082h.049V52.854l3.154-3.154h11.424Z",
    transform: "translate(-166.838 -49.198)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M184.717,52.75H173.4l-3.007,3.007v.586h.05v-.564l2.977-2.978h11.3Z",
    transform: "translate(-169.638 -51.998)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M186.117,54.3H174.859l-2.919,2.919v.524h.05v-.5l2.889-2.889h11.237Z",
    transform: "translate(-171.037 -53.397)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M187.516,55.85h-11.2l-2.831,2.831v.461h.05V58.7l2.8-2.8h11.175Z",
    transform: "translate(-172.437 -54.797)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M188.916,57.41H177.783l-2.743,2.742v.4h.05v-.378l2.713-2.713h11.113Z",
    transform: "translate(-173.837 -56.206)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1580",
    "data-name": "Group 1580",
    transform: "translate(0 14.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M170.893,206.02H169.02v.049h1.852l.865.864v3.75l2.779,2.779h5.265v-.049h-5.245l-2.75-2.75v-3.75Z",
    transform: "translate(-165.008 -204.816)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M161.609,204.46H158.67v.05h2.919l.952.952v2.64l2.691,2.691h5.2v-.05h-5.183l-2.662-2.662v-2.639Z",
    transform: "translate(-155.661 -203.407)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M161.671,202.91h-3v.05h2.981l1.04,1.04v2.639l2.6,2.6h5.141v-.05h-5.12l-2.573-2.573V203.98Z",
    transform: "translate(-155.661 -202.007)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M133.713,201.36H127.64v.05h6.051l1.129,1.129v2.639l2.514,2.514h5.079v-.049h-5.057l-2.485-2.485v-2.64Z",
    transform: "translate(-127.64 -200.608)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M133.775,199.81H127.64v.05h6.114l1.216,1.216v2.64l2.427,2.426h5.016v-.05h-5l-2.4-2.4v-2.639Z",
    transform: "translate(-127.64 -199.208)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M133.837,198.26h-6.2v.05h6.176l1.3,1.3v2.639l2.339,2.339h4.954v-.05H137.48l-2.309-2.309v-2.639Z",
    transform: "translate(-127.64 -197.808)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M161.921,196.71H158.67v.049h3.23l1.393,1.393v2.639l2.249,2.25h4.892v-.05h-4.87l-2.221-2.22v-2.64Z",
    transform: "translate(-155.661 -196.408)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M161.983,195.15H158.67v.05h3.292l1.482,1.482v2.639l2.162,2.162h4.829v-.05h-4.808l-2.133-2.132v-2.64Z",
    transform: "translate(-155.661 -195)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M171.392,193.6H169.02v.05h2.351l1.569,1.569v1.611l2.074,2.074h4.767v-.05h-4.746l-2.044-2.045V195.2Z",
    transform: "translate(-165.008 -193.6)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M160.034,154.95h-1.056l-1.056,1.056h-2.311l-1.056-1.056H150.78V155h3.754l1.056,1.056h2.352L159,155h1.056",
    transform: "translate(-148.536 -144.288)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M159.972,153.4h-1.056l-1.056,1.056h-2.186l-1.056-1.056H150.78v.05H154.6l1.056,1.056h2.227l1.056-1.056h1.056",
    transform: "translate(-148.536 -142.889)",
    fill: "url(#linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M159.909,151.85h-1.056l-1.055,1.056h-2.062l-1.056-1.056h-3.9v.05h3.879l1.056,1.056h2.1l1.056-1.056h1.056",
    transform: "translate(-148.536 -141.489)",
    fill: "url(#linear-gradient-138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M159.847,150.3h-1.056l-1.056,1.056H155.8l-1.056-1.056H150.78v.049h3.941l1.056,1.056h1.979l1.056-1.056h1.056",
    transform: "translate(-148.536 -140.089)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M159.785,148.75h-1.056l-1.056,1.056h-1.812L154.8,148.75H150.78v.049h4l1.056,1.056h1.854l1.056-1.056h1.056",
    transform: "translate(-148.536 -138.689)",
    fill: "url(#linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M159.723,147.19h-1.056l-1.056,1.056h-1.688l-1.056-1.056H150.78v.05h4.067L155.9,148.3h1.729l1.056-1.056h1.056",
    transform: "translate(-148.536 -137.281)",
    fill: "url(#linear-gradient-78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M159.66,145.64H158.6l-1.056,1.056h-1.563l-1.056-1.056H150.78v.05h4.129l1.056,1.056h1.6l1.056-1.056h1.056",
    transform: "translate(-148.536 -135.881)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1581",
    "data-name": "Group 1581",
    transform: "translate(3.746 15.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M167.657,207.71h-.05v.38l-1.041,1.041h-.3v.05h.317l1.07-1.071Z",
    transform: "translate(-166.27 -207.71)",
    fill: "url(#linear-gradient-143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M167.835,207.71h-.049v.559l-1.041,1.041h-.474v.049h.495l1.07-1.07Z",
    transform: "translate(-166.27 -207.71)",
    fill: "url(#linear-gradient-144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M168.013,207.71h-.05v.736l-1.04,1.041h-.653v.05h.673l1.07-1.07Z",
    transform: "translate(-166.27 -207.71)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M168.192,207.71h-.05v.914l-1.041,1.041h-.83v.05h.851l1.07-1.07Z",
    transform: "translate(-166.27 -207.71)",
    fill: "url(#linear-gradient-43)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M182.34,229.206h.05v-1.819l1.1-1.1v-.619l-.953-.953-.036.036.939.938v.578l-1.1,1.1Z",
    transform: "translate(-177.036 -207.293)",
    fill: "url(#linear-gradient-147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M180.7,230.393h.05v-1.819l.951-.951V227l-.794-.794-.035.036.779.779v.578l-.951.951Z",
    transform: "translate(-175.555 -208.639)",
    fill: "url(#linear-gradient-148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M179.07,231.534h.049v-1.819l.813-.812v-.619l-.635-.635-.036.035.621.621v.577l-.812.813Z",
    transform: "translate(-174.083 -209.939)",
    fill: "url(#linear-gradient-149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M176.142,132.4H174.02v.05h2.1l1.205,1.205h2.1v-.05h-2.085Z",
    transform: "translate(-169.523 -123.925)",
    fill: "url(#linear-gradient-72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M177.522,130.9H175.4v.049h2.1l1.205,1.205h1.972v-.049h-1.951Z",
    transform: "translate(-170.769 -122.57)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M178.9,129.39H176.78v.05h2.1l1.205,1.205h1.838v-.05h-1.817Z",
    transform: "translate(-172.015 -121.207)",
    fill: "url(#linear-gradient-78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M178.611,127.89h-2.3v.05h2.281l1.205,1.205h1.7v-.05h-1.684Z",
    transform: "translate(-171.591 -119.852)",
    fill: "url(#linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M178.745,126.39H176.31v.049h2.414l1.205,1.205H181.5V127.6h-1.55Z",
    transform: "translate(-171.591 -118.497)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M219.443,101.41h-4.6v3.439h.05V101.46h4.552Z",
    transform: "translate(-206.385 -95.94)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M217.51,99.27H212.7v3.44h.05V99.32h4.76Z",
    transform: "translate(-204.453 -94.007)",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M215.587,97.14H210.57v3.439h.049v-3.39h4.967Z",
    transform: "translate(-202.529 -92.084)",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M218.48,106.249h.594v-.05h-.544V104.64h-.05Z",
    transform: "translate(-209.672 -98.856)",
    fill: "url(#linear-gradient-158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M218.48,124.886h.05v-.946h.544v-.049h-.594Z",
    transform: "translate(-209.672 -116.24)",
    fill: "url(#linear-gradient-159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M223.871,109.79h-2.122l-.8.8.035.036.785-.784h2.1Z",
    transform: "translate(-211.903 -103.507)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M223.808,107.8h-2.2l-.729.729.036.035.714-.714h2.179Z",
    transform: "translate(-211.839 -101.71)",
    fill: "url(#linear-gradient-161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M223.844,105.82h-2.276l-.649.648.035.036.634-.634h2.255Z",
    transform: "translate(-211.876 -99.922)",
    fill: "url(#linear-gradient-162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M223.88,103.83h-2.353l-.567.567.036.035.553-.552h2.332Z",
    transform: "translate(-211.912 -98.125)",
    fill: "url(#linear-gradient-163)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1450",
    "data-name": "Rectangle 1450",
    width: 1.816,
    height: 0.05,
    transform: "translate(11.301 21.534)",
    fill: "url(#linear-gradient-164)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1451",
    "data-name": "Rectangle 1451",
    width: 1.816,
    height: 0.05,
    transform: "translate(11.301 21.7)",
    fill: "url(#linear-gradient-165)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1582",
    "data-name": "Group 1582",
    transform: "translate(7.225 13.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M210.489,191.318v-1.553l-1.144-1.145-.035.036,1.13,1.13v1.533Z",
    transform: "translate(-208.616 -188.543)",
    fill: "url(#linear-gradient-166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M209.059,192.619V191.2l-1.144-1.144-.035.035,1.13,1.13v1.394Z",
    transform: "translate(-207.324 -189.844)",
    fill: "url(#linear-gradient-167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M207.62,193.91v-1.276l-1.144-1.144-.036.035,1.13,1.13v1.256Z",
    transform: "translate(-206.024 -191.135)",
    fill: "url(#linear-gradient-168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M206.19,195.2v-1.137l-1.144-1.144-.036.035,1.13,1.13V195.2Z",
    transform: "translate(-204.733 -192.426)",
    fill: "url(#linear-gradient-169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M204.76,196.493v-1l-1.144-1.144-.036.035,1.13,1.13v.978Z",
    transform: "translate(-203.441 -193.718)",
    fill: "url(#linear-gradient-170)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M203.33,197.784v-.86l-1.144-1.144-.036.036,1.13,1.13v.839Z",
    transform: "translate(-202.15 -195.009)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M215.2,192.926v-3.217l-1.007-1.007h-1.4l-.872-.872-.036.035.887.887h1.4l.977.977v3.2Z",
    transform: "translate(-210.946 -187.83)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M225.2,203.674v-3.217l-1.007-1.006h-.95v.049h.93l.977.977v3.2Z",
    transform: "translate(-221.195 -198.323)",
    fill: "url(#linear-gradient-173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M225.018,205.515V202.3l-1.006-1.006h-.772v.05h.75l.978.977v3.2Z",
    transform: "translate(-221.195 -199.985)",
    fill: "url(#linear-gradient-174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M224.84,207.364v-3.217l-1.007-1.006h-.592v.049h.572l.977.977v3.2Z",
    transform: "translate(-221.195 -201.656)",
    fill: "url(#linear-gradient-173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M217.8,192.935v-3.349l-1.006-1.007h-1.4l-.739-.739-.036.035.754.754h1.4l.977.977v3.329Z",
    transform: "translate(-213.411 -187.839)",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M220.387,192.926v-3.482l-1.006-1.006h-1.4l-.608-.608-.035.035.622.623h1.4l.978.977v3.461Z",
    transform: "translate(-215.867 -187.83)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M222.985,192.935v-3.614l-1.006-1.006h-1.4l-.476-.475-.035.035.49.491h1.4l.977.977v3.592Z",
    transform: "translate(-218.332 -187.839)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M225.565,192.926v-3.746l-1.007-1.006h-1.4l-.344-.344-.036.035.359.359h1.4l.977.978v3.724Z",
    transform: "translate(-220.78 -187.83)",
    fill: "url(#linear-gradient-41)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1452",
    "data-name": "Rectangle 1452",
    width: 1.421,
    height: 0.05,
    transform: "translate(3.563 19.44)",
    fill: "url(#linear-gradient-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1453",
    "data-name": "Rectangle 1453",
    width: 1.421,
    height: 0.05,
    transform: "translate(3.21 19.145)",
    fill: "url(#linear-gradient-181)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1454",
    "data-name": "Rectangle 1454",
    width: 1.421,
    height: 0.05,
    transform: "translate(3.21 18.85)",
    fill: "url(#linear-gradient-182)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1455",
    "data-name": "Rectangle 1455",
    width: 2.138,
    height: 0.05,
    transform: "translate(12.36 18.07)",
    fill: "url(#linear-gradient-183)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1456",
    "data-name": "Rectangle 1456",
    width: 2.138,
    height: 0.05,
    transform: "translate(12.36 17.776)",
    fill: "url(#linear-gradient-184)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1457",
    "data-name": "Rectangle 1457",
    width: 3.592,
    height: 0.05,
    transform: "translate(10.905 18.894)",
    fill: "url(#linear-gradient-185)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1458",
    "data-name": "Rectangle 1458",
    width: 1.421,
    height: 0.05,
    transform: "translate(3.563 18.554)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1459",
    "data-name": "Rectangle 1459",
    width: 1.421,
    height: 0.05,
    transform: "translate(3.21 18.26)",
    fill: "url(#linear-gradient-187)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1583",
    "data-name": "Group 1583",
    transform: "translate(1.991 12.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M156.431,179.8H154.31v.05h2.1l.528.528h1.056l.535.535.036-.036-.55-.55H156.96Z",
    transform: "translate(-153.715 -179.081)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M192.275,182.85l-.035.036,1.055,1.056.036-.036Z",
    transform: "translate(-187.967 -181.835)",
    fill: "url(#linear-gradient-189)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1460",
    "data-name": "Rectangle 1460",
    width: 2.706,
    height: 0.05,
    transform: "translate(0 0.48)",
    fill: "url(#linear-gradient-190)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M192.275,180.38l-.035.035,1.055,1.056.036-.035Z",
    transform: "translate(-187.967 -179.604)",
    fill: "url(#linear-gradient-189)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1461",
    "data-name": "Rectangle 1461",
    width: 2.706,
    height: 0.05,
    transform: "translate(0 0.239)",
    fill: "url(#linear-gradient-180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M156.431,172.38H154.31v.05h2.1l.528.527h1.056l.535.535.036-.035-.55-.55H156.96Z",
    transform: "translate(-153.715 -172.38)",
    fill: "url(#linear-gradient-81)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1584",
    "data-name": "Group 1584",
    transform: "translate(8.522 16.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M217.026,215.3h-.412l-.86.86h-.224v.05h.244l.861-.86h.391Z",
    transform: "translate(-215.53 -215.3)",
    fill: "url(#linear-gradient-194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M217.026,217.61h-.412l-.86.861h-.224v.05h.244l.861-.861h.391Z",
    transform: "translate(-215.53 -217.386)",
    fill: "url(#linear-gradient-107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M217.026,219.93h-.412l-.86.86h-.224v.05h.244l.861-.861h.391Z",
    transform: "translate(-215.53 -219.481)",
    fill: "url(#linear-gradient-196)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M160.348,161.13H157.69v.049h2.636l1.082,1.082h1.033v-.049H161.43Z",
    transform: "translate(-154.776 -149.869)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M155.435,157.86H152.25v.05h3.164l1.082,1.081h1.561v-.049h-1.54Z",
    transform: "translate(-149.864 -146.916)",
    fill: "url(#linear-gradient-81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M179.725,99.72H178.67l-1.89,1.89.035.036,1.875-1.875h1.035Z",
    transform: "translate(-172.015 -94.413)",
    fill: "url(#linear-gradient-105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M178.117,102.47h-1.055L175,104.531l.036.036,2.047-2.048h1.035Z",
    transform: "translate(-170.408 -96.897)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M179.363,105.21h-1.055l-1.929,1.929.035.036,1.914-1.914h1.035Z",
    transform: "translate(-171.654 -99.371)",
    fill: "url(#linear-gradient-201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M183.436,107.95h-1.055l-1.491,1.491.036.035L182.4,108h1.035Z",
    transform: "translate(-175.727 -101.845)",
    fill: "url(#linear-gradient-202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M194.709,118.74h-.891l-.428.428.035.036.414-.414h.87Z",
    transform: "translate(-187.015 -111.589)",
    fill: "url(#linear-gradient-203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M185.741,116.01h-.891l-.823.823h-.567v.05h.588l.824-.823h.87Z",
    transform: "translate(-178.048 -109.124)",
    fill: "url(#linear-gradient-163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M187.381,113.29h-.59l-.823.823h-.359v.049h.379l.824-.823h.568Z",
    transform: "translate(-179.989 -106.668)",
    fill: "url(#linear-gradient-205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M189.215,110.56h-.59l-.823.823h-.162v.05h.182l.824-.823h.568Z",
    transform: "translate(-181.822 -104.202)",
    fill: "url(#linear-gradient-166)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1586",
    "data-name": "Group 1586",
    transform: "translate(5.922 2.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M143.64,145.267v-.247h.779v.611l-.417,0Z",
    transform: "translate(-141.833 -137.291)",
    fill: "url(#linear-gradient-207)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1462",
    "data-name": "Rectangle 1462",
    width: 0.725,
    height: 0.271,
    transform: "translate(5.265 13.74)",
    fill: "url(#linear-gradient-208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M125.857,196.12v.367l-.315.315H125v-.682Z",
    transform: "translate(-125 -183.437)",
    fill: "url(#linear-gradient-209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M159.416,213.947l-.314.315h-.542v-.682h.856Z",
    transform: "translate(-155.306 -199.204)",
    fill: "url(#linear-gradient-210)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M163.218,66.5H160.7l-1.037,1.037v.1l-.526.526H157.65v-.75H159.5l1.246-1.246h1.759l.85-.849h.924v.742h-.619Z",
    transform: "translate(-154.484 -65.31)",
    fill: "url(#linear-gradient-72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M156.987,125.025l-.536-.536h-2.03V123.21h2.693v.692l-.4.4.277.276h1.337l1.081,1.081h1.941v.643h-1.927l-1.274-1.274Z",
    transform: "translate(-151.567 -117.596)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M211.468,231.776l-1.608-1.608v-.709l1.672,1.672Z",
    transform: "translate(-201.632 -213.544)",
    fill: "url(#linear-gradient-75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M128.84,166.84h5.585l.8.8H133.98l-.449-.448H128.84Z",
    transform: "translate(-128.468 -156.996)",
    fill: "url(#linear-gradient-48)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1587",
    "data-name": "Group 1587",
    transform: "translate(6.039 2.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M145.395,146.22h-.545v.082l.293.293.252,0Z",
    transform: "translate(-143.043 -138.492)",
    fill: "url(#linear-gradient-215)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1463",
    "data-name": "Rectangle 1463",
    width: 0.492,
    height: 0.037,
    transform: "translate(5.265 13.74)",
    fill: "url(#linear-gradient-216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M126.587,197.768l.246-.246v-.2h-.623v.448Z",
    transform: "translate(-126.21 -184.638)",
    fill: "url(#linear-gradient-217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M160.137,215.229l.246-.247v-.2h-.623v.449Z",
    transform: "translate(-156.507 -200.405)",
    fill: "url(#linear-gradient-218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M158.86,69.131v-.516h1.778v.059l-.457.457Zm2.926-1.658.1-.1h1.759l.849-.849h.759v.509h-.55l-.445.445h-2.476Z",
    transform: "translate(-155.694 -66.52)",
    fill: "url(#linear-gradient-138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M162.318,127.275v-.409h-1.872l-1.08-1.08h-1.338l-.394-.394.445-.445v-.526H155.62v1.045h1.962l.536.536h1.164l1.274,1.273Z",
    transform: "translate(-152.768 -118.806)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M212.493,233.8l-1.433-1.433v.378l1.4,1.4Z",
    transform: "translate(-202.833 -216.289)",
    fill: "url(#linear-gradient-221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M135.469,168.05H130.05v.119h4.622l.449.449h.916Z",
    transform: "translate(-129.678 -158.206)",
    fill: "url(#linear-gradient-222)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M163.52,185.75l.573.592h1.32l-.592-.592Z",
    transform: "translate(-153.863 -171.455)",
    fill: "url(#linear-gradient-223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M181.26,190.542l.027-.026-1.906-1.906H178.04v.038h1.325Z",
    transform: "translate(-166.975 -174.038)",
    fill: "url(#linear-gradient-81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M176.667,39.354l1.006-1.007-.026-.026-1.007,1.007Z",
    transform: "translate(-165.711 -38.32)",
    fill: "url(#linear-gradient-225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M179.766,39.354l1.007-1.007-.026-.026-1.007,1.007Z",
    transform: "translate(-168.511 -38.32)",
    fill: "url(#linear-gradient-226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M182.866,39.354l1.007-1.007-.026-.026-1.007,1.007Z",
    transform: "translate(-171.31 -38.32)",
    fill: "url(#linear-gradient-227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M185.966,39.354l1.007-1.007-.027-.026-1.006,1.007Z",
    transform: "translate(-174.109 -38.32)",
    fill: "url(#linear-gradient-228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M159.23,66.2h.037v-.866l1.51-1.51-.026-.026-1.52,1.52Z",
    transform: "translate(-149.989 -61.329)",
    fill: "url(#linear-gradient-229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M141.23,70.242h1.3v-.791l.9-.9-.027-.027-.914.914v.77H141.23Z",
    transform: "translate(-133.735 -65.592)",
    fill: "url(#linear-gradient-230)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M149.9,71.264h.038v-.529l.757-.757-.027-.027-.768.769Z",
    transform: "translate(-141.564 -66.883)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M194.226,61.525l1.108-1.107h2.116V60.38h-2.132L194.2,61.5Z",
    transform: "translate(-181.569 -58.241)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M198.8,63.9l.863-.863-.026-.027-.863.864Z",
    transform: "translate(-185.695 -60.616)",
    fill: "url(#linear-gradient-233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M203.366,63.855l.857-.857h2.116V62.96h-2.131l-.868.869Z",
    transform: "translate(-189.822 -60.571)",
    fill: "url(#linear-gradient-107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M66.649,73.336h1.475V73.3H66.649a1.036,1.036,0,0,1-1.064-.9.78.78,0,0,1,.038-.529.765.765,0,0,0,.057-.227c0-.019,0-.039,0-.057.016-.213.03-.414-.207-.565-.134-.085-.2-.176-.207-.271a.329.329,0,0,1,.149-.249c.078-.057.084-.109.077-.142-.016-.069-.112-.125-.256-.151a.135.135,0,0,1-.1-.07.829.829,0,0,1,.075-.6.627.627,0,0,0-.048-.589,1.008,1.008,0,0,0-.437-.3c-.056-.025-.12-.054-.19-.088l-.083-.041c-.271-.131-.505-.243-.494-.58a2.168,2.168,0,0,1,.5-.931c.107-.146.217-.3.305-.441a5.914,5.914,0,0,0,.609-1.207,3.041,3.041,0,0,0,.04-.567c0-.108,0-.219.009-.337,0-.076.007-.148.01-.218.01-.217.018-.423.035-.665a6.508,6.508,0,0,1,.43-1.992,9.372,9.372,0,0,1,1.19-2.075,6.8,6.8,0,0,1,1.145-1.128,4.389,4.389,0,0,1,2.851-1.092h1.165V57.25H71.083a4.424,4.424,0,0,0-2.874,1.1,6.847,6.847,0,0,0-1.152,1.134,9.422,9.422,0,0,0-1.195,2.084,6.541,6.541,0,0,0-.432,2c-.016.242-.025.448-.035.666,0,.071-.007.143-.01.218-.006.119-.007.231-.009.339a3.031,3.031,0,0,1-.039.559,5.98,5.98,0,0,1-.6,1.2c-.088.143-.2.294-.3.439a2.176,2.176,0,0,0-.5.952c-.013.361.243.484.515.615l.083.041c.07.035.134.063.191.089a.972.972,0,0,1,.424.286.59.59,0,0,1,.042.553.847.847,0,0,0-.073.63.172.172,0,0,0,.126.088c.125.022.213.071.226.123s-.029.078-.063.1a.365.365,0,0,0-.164.281.4.4,0,0,0,.224.3c.218.139.2.321.189.53,0,.019,0,.039,0,.058a.747.747,0,0,1-.055.216.824.824,0,0,0-.039.552A1.083,1.083,0,0,0,66.649,73.336Z",
    transform: "translate(-63.925 -55.415)",
    fill: "url(#linear-gradient-235)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1591",
    "data-name": "Group 1591",
    transform: "translate(74.404 38.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1589",
    "data-name": "Group 1589",
    transform: "translate(7.164 21.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M256.349,311.457l.627,3.876a6.912,6.912,0,0,1-6.659.4,7.392,7.392,0,1,1,10.315-6.83c.039,2.431.007,4.862.007,7.283a3.178,3.178,0,0,1-3.454-3.315c-.048-1.408.043-2.823-.043-4.227a3.9,3.9,0,0,0-4.345-3.57,3.952,3.952,0,0,0-3.4,4.393,3.908,3.908,0,0,0,6.106,2.673C255.8,311.933,256.076,311.681,256.349,311.457Z",
    transform: "translate(-245.884 -297.931)",
    fill: "url(#linear-gradient-236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M364.4,265.99a1.766,1.766,0,0,1-1.837,1.77A1.813,1.813,0,0,1,360.8,265.9a1.834,1.834,0,0,1,1.856-1.771A1.767,1.767,0,0,1,364.4,265.99Z",
    transform: "translate(-349.655 -264.132)",
    fill: "url(#linear-gradient-236)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M369.068,308.67H366.02s2.672,1.187,3.048,2.83Z",
    transform: "translate(-347.208 -283.093)",
    fill: "url(#linear-gradient-236)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1590",
    "data-name": "Group 1590",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M204.093,88.3a.264.264,0,0,1-.126.226,21.73,21.73,0,0,1-6.011,2.333,31.465,31.465,0,0,1-7.564.92q-8.69,0-13.541-4.155A13.738,13.738,0,0,1,172,76.656a12.889,12.889,0,0,1,1.712-6.676,14.131,14.131,0,0,1,4.449-4.616.263.263,0,0,0,.006-.434,11.1,11.1,0,0,1-2.472-2.734,8.337,8.337,0,0,1-1.538-4.852,12.033,12.033,0,0,1,3.536-9.007,12.579,12.579,0,0,1,9.181-3.457,22.868,22.868,0,0,1,4.36.4q1.6.311,2.164.417a.282.282,0,0,1,.23.278v5.444a.283.283,0,0,1-.283.283h0a.264.264,0,0,1-.067-.009q-.829-.22-2.647-.578a18.267,18.267,0,0,0-3.5-.365,8.048,8.048,0,0,0-5.74,1.887,6.4,6.4,0,0,0-2,4.868,5.526,5.526,0,0,0,1.141,3.267,7.082,7.082,0,0,0,2.212,2.133.26.26,0,0,0,.213.016L194.505,58.8a2.6,2.6,0,0,1,3.466,2.444h0a2.6,2.6,0,0,1-1.735,2.448L184.525,67.81a11.423,11.423,0,0,0-5.455,3.6,8.257,8.257,0,0,0-1.807,5.185,8.042,8.042,0,0,0,3.489,6.771q3.488,2.584,9.546,2.585a23.324,23.324,0,0,0,7.294-1.316,22.516,22.516,0,0,0,6.084-2.884.257.257,0,0,1,.154-.05h0a.264.264,0,0,1,.264.264V88.3Z",
    transform: "translate(-172 -44.88)",
    fill: "url(#linear-gradient-236)"
  }))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "AAI",
    transform: "translate(83.193 34.035)",
    fill: "#1171d8",
    fontSize: 29,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.795,
    y: 0
  }, "AAI"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLogo);
export default __webpack_public_path__ + "static/media/dashboardLogo.c49903146c719ad7050bf908461be309.svg";
export { ForwardRef as ReactComponent };